<template>
  <div>
    <!-- <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('profile') }}
    </h1> -->
    <div class="profileImg">
      <div class="userAccount">
        <div class="userAccount__image">
          <img class="user_img" src="../../assets/apps4all/imgs/dummy_account.jpeg"/>
        </div>
        <div class="userAccount__name">
          <h1 class="mobiTitle md">{{$t("hello")}}!</h1>
        </div>
      </div>
    </div>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content userProfile">
          <div class="userProfile">
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('registered_num') }}:</label>
              <h2 class="mobiTitle md text_color">{{msisdn_a4all}}</h2>
            </div>
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('subscription_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{subscription_date_a4all}}</h2>
            </div>  
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('next_renew_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{renew_date_a4all}}</h2>
            </div>
          </div>
          <div class="btnContainer " v-if="authentication_a4all === 'loggedin'">
            <div v-if="is_unsub_a4all != '0'">
              <a @click="logout_a4all(is_unsub_a4all)" href="" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
            <div v-else-if="countryCode === 'fi'">
            </div>
            <div v-else>
              <a @click="logout_a4all(is_unsub_a4all)"  href="/logout" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "msisdn_a4all",
    "renew_date_a4all",
    "subscription_date_a4all",
    "authentication_a4all",
    "is_unsub_a4all",
    "countryCode"
  ]),
  methods: {
    ...mapActions(["logout_a4all"]),
  },
};
</script>

<style scoped lang="scss">
.userProfile {
  .mobiBtn {
    background: #e51520;
  }
}
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #fff;
  }
  margin-top: 15px;
}
.inputWrap__label {
  color: #fff;
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/apps4all/Profile.vue